export const GET_SHELVES = "GET_SHELVES";
export const GET_SHELVE_BY_ID = "GET_SHELVE_BY_ID";
export const UPDATE_SHELVE = "UPDATE_SHELVE";
export const DELETE_SHELVE = "DELETE_SHELVE";
export const CREATE_SHELVE = "CREATE_SHELVE";
